"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBComputerNegative = function SvgBComputerNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M15.404 80.612a2.107 2.107 0 01-2.107-2.107V8.844A8.858 8.858 0 0122.141 0h99.444a8.85 8.85 0 018.837 8.844v3.203a2.107 2.107 0 01-2.107 2.107H25.372a2.107 2.107 0 110-4.214h100.835V8.844a4.63 4.63 0 00-4.622-4.63H22.141a4.63 4.63 0 00-4.63 4.63v69.66a2.107 2.107 0 01-2.107 2.108zM75.161 81.483H68.53a2.107 2.107 0 110-4.215h6.631a2.107 2.107 0 110 4.215zM128.315 90.032a2.107 2.107 0 01-2.108-2.108v-65.86a2.107 2.107 0 114.215 0v65.86a2.107 2.107 0 01-2.107 2.108z"
  }), (0, _core.jsx)("path", {
    d: "M134.377 103.792H9.132A9.132 9.132 0 010 94.661v-6.238c0-1.164.943-2.107 2.107-2.107h13.297a2.107 2.107 0 110 4.214H4.214v4.13a4.917 4.917 0 004.918 4.918h125.245a4.917 4.917 0 004.917-4.917v-4.13H25.288a2.107 2.107 0 110-4.215h116.134c1.164 0 2.107.943 2.107 2.107v6.238a9.167 9.167 0 01-9.152 9.131zM25.288 70.553a2.108 2.108 0 01-1.49-3.597l46.446-46.403a2.111 2.111 0 112.985 2.986L26.805 69.935a2.108 2.108 0 01-1.517.618zM25.288 40.79a2.108 2.108 0 01-1.461-3.56l16.62-16.656a2.107 2.107 0 112.978 2.979l-16.62 16.62a2.108 2.108 0 01-1.517.618z"
  })));
};

var _default = SvgBComputerNegative;
exports["default"] = _default;